<template>
  <div class="app-bar" v-if="!isZaiart">
    <div class="inner" :style="style">
      <div class="zaiart-icon"></div>
      <a class="open-btn js-goApp" href="javascript:;">立即打开</a>
    </div>
  </div>
</template>
<script>
import { isZaiart } from '@/utils/utils'
export default {
  name: 'AppBar',
  props: {
    position: { type: String },
    width: { type: String },
    dataId: { required: true },
    dataType: { required: true }
  },
  data() {
    return {
      mlink: null,
      isZaiart: isZaiart
    }
  },
  computed: {
    style() {
      return (
        this.position && {
          position: 'fixed',
          left: 0,
          top: this.position === 'top' ? 0 : false,
          right: 0,
          bottom: this.position === 'bottom' ? 0 : false,
          maxWidth: this.width || false
        }
      )
    }
  },
  methods: {},
  mounted() {
    var buttons = document.querySelectorAll('.js-goApp')
    if (window.Mlink) {
      try {
        this.mlink = new window.Mlink({
          mlink: 'AAyN',
          button: buttons,
          autoLaunchApp: false,
          autoRedirectToDownloadUrl: true,
          downloadWhenUniversalLinkFailed: true,
          inapp: false,
          params: {
            dataId: this.dataId,
            dataType: this.dataType,
            dataTitle: ''
          }
        })
      } catch (e) {}
    } else {
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener(
          'click',
          () => {
            location.href =
              'http://a.app.qq.com/o/simple.jsp?pkgname=com.zaiart.yi'
          },
          false
        )
      }
    }
  }
}
</script>
<style>
/* app-bar */
.app-bar {
  position: relative;
  height: 48px;
  z-index: 1000;
}
.app-bar .fixed {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 1000;
}
.app-bar .inner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 20px;
  margin: 0 auto;
  background: linear-gradient(180deg, rgba(25, 25, 30, 1), rgba(27, 27, 30, 1));
  box-shadow: 0px 0.5px 10px 0px rgba(45, 45, 45, 1);
  opacity: 0.9;
}
.app-bar .zaiart-icon {
  flex: 1;
  background: url(../assets/img/app_bar_new.png) no-repeat left center;
  height: 32px;
  background-size: contain;
}
.app-bar .open-btn {
  width: 90px;
  height: 32px;
  border: 1px solid #57aef1;
  color: #57aef1;
  border-radius: 4px;
  font-size: 13px;
  line-height: 30px;
  text-align: center;
  letter-spacing: 2px;
}
</style>
